import classnames from "classnames";
import compact from "lodash/compact";
import pick from "lodash/pick";
import React from "react";
import EmptyProfileIcon from "../icons/EmptyProfile.svg";
import { BUILD_TARGETS, useBuildTargetContext } from "../../target-context";
import { NotificationsOutlined, Menu } from "@mui/icons-material";
import { navigateTo, setParams, getParams } from "../../utils/location";

import * as styles from "./HeaderUserProfileLink.module.scss";
import WebsiteHeaderMenu from "./WebsiteHeaderMenu";

const userGreeting = username => {
  if (!username) return "";
  const firstName = username
    .trim()
    .split(" ")[0]
    .trim();
  if (!firstName) return "";
  return firstName;
};

export default ({
  orderUrl,
  loggedIn,
  loginLabelText,
  loginLabelDesktopExtraText,
  showLabel,
  userDetails,
  T,
  onLoginClicked,
  onUserOpenAccountMenuClicked,
  amountOfGiftsUnseen,
  appStyles,
  unseenMessagesCount = 0,
}) => {
  const target = useBuildTargetContext();
  const onClick = () => {
    if (loggedIn) {
      onUserOpenAccountMenuClicked();
    } else {
      onLoginClicked();
    }
  };
  const userLoggedIn = loggedIn && userDetails && userDetails.data;
  const { HeaderLoginButton } = appStyles;
  const getLabelText = () => (
    <span key="profileGreeting">
      <span
        className={classnames(styles.Username, styles.HideOnDesktop)}
        style={appStyles.noIcons ? { margin: 0 } : {}}
      >
        {userLoggedIn
          ? `${T("Hi")} ${userGreeting(userDetails.data.name)}!`
          : loginLabelText}
      </span>

      <span
        className={classnames(
          styles.Username,
          styles.HideOnMobile,
          appStyles.rtl && styles.RTL,
        )}
        style={appStyles.noIcons ? { margin: 0 } : {}}
      >
        {userLoggedIn
          ? `${T("Hi")} ${userGreeting(userDetails.data.name)}!`
          : loginLabelText + loginLabelDesktopExtraText}
      </span>
    </span>
  );

  if(target === BUILD_TARGETS.WEBSITE) {
    return (
     <WebsiteHeaderMenu orderUrl={orderUrl} T={T} appStyles={appStyles} />
    );
   }

  const handleBellClick = (e) => {
    e.stopPropagation();
    if (userLoggedIn) {
      navigateTo(setParams("/in-app-messages", getParams(window.location)));
    } else {
      onLoginClicked();
    }
  };

  return (
    !userDetails.loading && (
      <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
        {/* Bell Icon for In-App Messages */}
        {userLoggedIn && (
          <div
            onClick={handleBellClick}
            className={styles.bellIcon}
            role="button"
            aria-label={T("Messages")}
            style={{ 
              position: "relative",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <NotificationsOutlined 
              sx={{ 
                fontSize: 26, 
                color: appStyles.headerTextColor || appStyles.actionColor,
              }} 
            />
            {unseenMessagesCount > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: -2,
                  right: -2,
                  backgroundColor: appStyles.actionColor,
                  color: "#fff",
                  fontSize: 9,
                  fontWeight: 700,
                  width: 18,
                  height: 18,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  lineHeight: 1,
                }}
              >
                {unseenMessagesCount > 99 ? "99+" : unseenMessagesCount}
              </span>
            )}
          </div>
        )}

        {/* Menu / Login Button */}
        <div
          onClick={onClick}
          className={classnames(styles.user, appStyles.rtl && styles.RTL)}
          style={
            userLoggedIn
              ? { 
                  color: appStyles.headerTextColor,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 4,
                }
              : {
                  color: "white",
                  backgroundColor: appStyles.actionColor,
                  ...pick(
                    appStyles.Button,
                    "color",
                    "background",
                    "backgroundColor",
                    "border",
                  ),
                  padding: showLabel ? "5px 10px" : 5,
                  borderRadius: 50,
                  ...HeaderLoginButton,
                }
          }
          role="button"
          aria-label={userLoggedIn ? T("My Account") : T("Login")}
        >
          {userLoggedIn ? (
            <Menu 
              sx={{ 
                fontSize: 28, 
                color: appStyles.headerTextColor || appStyles.actionColor,
              }} 
            />
          ) : (
            compact([
              showLabel && getLabelText(),
              !showLabel && appStyles.noIcons && getLabelText(),
              !appStyles.noIcons && <EmptyProfileIcon key="emptyProfile" />,
            ])
          )}
        </div>
      </div>
    )
  );
};
